import mixpanel from '@webtrader/core/mix-panel';
import { TMixpanelSuperProperties } from '@webtrader/core/mix-panel/types';

class SuperPropertiesService {
  public registerSuperProperties = (properties: TMixpanelSuperProperties) => {
    mixpanel.registerSuperProperties({
      ...properties
    });
  };
}

const superPropertiesService = new SuperPropertiesService();
export default superPropertiesService;
